import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as GigsSupportActions from "../../../store/actions/GigsSupport";
import * as UserActions from "./../../../store/actions/User";
import {
  isValidated as isValidatedForMandatoryFields,
  filterObj,
} from "../../../utils";
import styles from "../../../constants/assets/variables";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const GigsSupportModal = ({
  modalState,
  handleClose,
  activeFilters,
  getGigsSupportList,
  resetGigsSupportStore,
  setStatus,
  slotHistoryDetail,
  setSlotHistoryDetail,
}) => {
  const [initialState, setInitialState] = useState({
    driver_id: "",
    slot_capacity_id: "",
    start_date: "",
    end_date: "",
  });
  const [currentDate, setCurrentDate] = useState();

  const isValidated = (body) => {
    let hasNoErrors = true;
    let validationState = isValidatedForMandatoryFields(body, [
      "driver_id",
      "start_date",
      "end_date",
    ]);
    let slotCapacityValidation = isValidatedForMandatoryFields(body, [
      "driver_id",
      "slot_capacity_id",
    ]);
    if (
      validationState !== "validated" &&
      slotCapacityValidation !== "validated"
    ) {
      hasNoErrors = false;
      setStatus({
        type: "error",
        message:
          "Either Slot capacity id or Start Date, End Date is required along with FE ID",
      });
    }

    if (body["start_date"] && body["end_date"]) {
      let endDate = new Date(body["end_date"]);
      let startDate = new Date(body["start_date"]);
      if (startDate > endDate) {
        hasNoErrors = false;
        setStatus({
          type: "error",
          message: "Start date should come before end date",
        });
      }
    }
    return hasNoErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const filterFields = Object.keys(initialState);
    let body = filterObj(initialState, filterFields);
    if (!isValidated(body)) {
      return;
    }
    let filters = {};
    for (let key of filterFields) {
      if (body[key] !== "") {
        filters[key] = body[key] + "";
      }
    }

    getGigsSupportList(filters).then((_) => {
      if (slotHistoryDetail.length > 0) {
        setSlotHistoryDetail([]);
      }
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetGigsSupportStore();
    handleClose();
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  useEffect(() => {
    setCurrentDate(new Date().toISOString().substring(0, 10));
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      Object.keys(values).forEach((key, _) => {
        if (activeFilters[key]) {
          values[key] = activeFilters[key];
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading={"Rider Slot Details Filter"}
      id="gigsSupportFilterModal"
      handleClose={handleClose}
      modalButtons={
        <BottomSectionModal>
          <FlexContainer>
            <Button
              data-testid="saveButton"
              onClick={handleClearFilters}
              className="sushi-btn"
            >
              Clear
            </Button>
            <Button
              data-testid="applyFiltersButton"
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Apply
            </Button>
          </FlexContainer>
        </BottomSectionModal>
      }
    >
      <div>
        <Input
          value={initialState.driver_id}
          onChange={(e) => handleChange("driver_id", e)}
          id="sushi-input"
          label="Driver FE ID"
          data-testId="DriverId"
          required={true}
          fullWidth={true}
          borderColor={styles.primaryColor}
          autoFocus={true}
        />
        <Input
          type="number"
          value={initialState.slot_capacity_id}
          onChange={(e) => handleChange("slot_capacity_id", e)}
          id="sushi-input"
          label="Slot Capacity Id"
          required={false}
          fullWidth={true}
          borderColor={styles.primaryColor}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          borderColor={styles.primaryColor}
          label="Start Date"
          data-testId="StartDate"
          type="date"
          value={initialState.start_date ? initialState.start_date : "  "}
          onChange={(e) => handleChange("start_date", e)}
          fullWidth={true}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          label="End Date"
          data-testId="EndDate"
          type="date"
          value={initialState.end_date ? initialState.end_date : "  "}
          onChange={(e) => handleChange("end_date", e)}
          fullWidth={true}
          borderColor={styles.primaryColor}
        />
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { GigsSupport } = state;
  return {
    activeFilters: GigsSupport.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetGigsSupportStore: () => dispatch(GigsSupportActions.resetState({})),
    getGigsSupportList: bindActionCreators(
      GigsSupportActions.getGigsSupportList,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GigsSupportModal);
